var _regeneratorRuntime = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _require = require("@truffle/interface-adapter"),
    Web3Shim = _require.Web3Shim,
    InterfaceAdapter = _require.InterfaceAdapter;

var utils = require("../utils");

var execute = require("../execute");

var bootstrap = require("./bootstrap");

module.exports = function (Contract) {
  return {
    setProvider: function setProvider(provider) {
      if (!provider) {
        throw new Error("Invalid provider passed to setProvider(); provider is ".concat(provider));
      }

      this.web3.setProvider(provider);
      this.interfaceAdapter.setProvider(provider);
      this.currentProvider = provider;
    },
    new: function _new() {
      utils.checkProvider(this);

      if (!this.bytecode || this.bytecode === "0x") {
        throw new Error("".concat(this.contractName, " error: contract binary not set. Can't deploy new instance.\n") + "This contract may be abstract, not implement an abstract parent's methods completely\n" + "or not invoke an inherited contract's constructor correctly\n");
      }

      var constructorABI = this.abi.filter(function (i) {
        return i.type === "constructor";
      })[0];
      return execute.deploy.call(this, constructorABI).apply(void 0, arguments);
    },
    at: function () {
      var _at = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(address) {
        var onChainCode;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(address == null || typeof address !== "string" || address.length !== 42)) {
                  _context.next = 2;
                  break;
                }

                throw new Error("Invalid address passed to ".concat(this.contractName, ".at(): ").concat(address));

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return this.detectNetwork();

              case 5:
                _context.next = 7;
                return this.web3.eth.getCode(address);

              case 7:
                onChainCode = _context.sent;
                _context.next = 10;
                return utils.checkCode(onChainCode, this.contractName, address);

              case 10:
                return _context.abrupt("return", new this(address));

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](2);
                throw _context.t0;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 13]]);
      }));

      function at(_x) {
        return _at.apply(this, arguments);
      }

      return at;
    }(),
    deployed: function () {
      var _deployed = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                utils.checkProvider(this);
                _context2.next = 4;
                return this.detectNetwork();

              case 4:
                utils.checkNetworkArtifactMatch(this);
                utils.checkDeployment(this);
                return _context2.abrupt("return", new this(this.address));

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                throw _context2.t0;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function deployed() {
        return _deployed.apply(this, arguments);
      }

      return deployed;
    }(),
    defaults: function defaults(class_defaults) {
      var _this = this;

      if (this.class_defaults == null) {
        this.class_defaults = {};
      }

      if (class_defaults == null) {
        class_defaults = {};
      }

      Object.keys(class_defaults).forEach(function (key) {
        var value = class_defaults[key];
        _this.class_defaults[key] = value;
      });
      return this.class_defaults;
    },
    hasNetwork: function hasNetwork(network_id) {
      return this._json.networks["".concat(network_id)] != null;
    },
    isDeployed: function isDeployed() {
      if (this.network_id == null) {
        return false;
      }

      if (this._json.networks[this.network_id] == null) {
        return false;
      }

      return !!this.network.address;
    },
    detectNetwork: function () {
      var _detectNetwork = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var _ref, gasLimit, chainNetworkID, _ref2, _gasLimit;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.network_id && this.networks[this.network_id] != null)) {
                  _context3.next = 12;
                  break;
                }

                _context3.prev = 1;
                _context3.next = 4;
                return this.web3.eth.getBlock("latest");

              case 4:
                _ref = _context3.sent;
                gasLimit = _ref.gasLimit;
                return _context3.abrupt("return", {
                  id: this.network_id,
                  blockLimit: gasLimit
                });

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](1);
                throw _context3.t0;

              case 12:
                _context3.prev = 12;
                _context3.next = 15;
                return this.interfaceAdapter.getNetworkId();

              case 15:
                chainNetworkID = _context3.sent;
                _context3.next = 18;
                return this.web3.eth.getBlock("latest");

              case 18:
                _ref2 = _context3.sent;
                _gasLimit = _ref2.gasLimit;
                _context3.next = 22;
                return utils.setInstanceNetworkID(this, chainNetworkID, _gasLimit);

              case 22:
                return _context3.abrupt("return", _context3.sent);

              case 25:
                _context3.prev = 25;
                _context3.t1 = _context3["catch"](12);
                throw _context3.t1;

              case 28:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 9], [12, 25]]);
      }));

      function detectNetwork() {
        return _detectNetwork.apply(this, arguments);
      }

      return detectNetwork;
    }(),
    setNetwork: function setNetwork(network_id) {
      if (!network_id) return;
      this.network_id = "".concat(network_id);
    },
    setNetworkType: function setNetworkType() {
      var networkType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "ethereum";

      if (this.web3) {
        this.web3.setNetworkType(networkType);
      }

      this.networkType = networkType;
    },
    setWallet: function setWallet(wallet) {
      this.web3.eth.accounts.wallet = wallet;
    },
    // Overrides the deployed address to null.
    // You must call this explicitly so you don't inadvertently do this otherwise.
    resetAddress: function resetAddress() {
      delete this.network.address;
    },
    link: function link(name, address) {
      var _this2 = this;

      // Case: Contract.link(instance)
      if (typeof name === "function") {
        var contract = name;

        if (contract.isDeployed() === false) {
          throw new Error("Cannot link contract without an address.");
        }

        this.link(contract.contractName, contract.address); // Merge events so this contract knows about library's events

        Object.keys(contract.events).forEach(function (topic) {
          _this2.network.events[topic] = contract.events[topic];
        });
        return;
      } // Case: Contract.link({<libraryName>: <address>, ... })


      if (typeof name === "object") {
        var obj = name;
        Object.keys(obj).forEach(function (name) {
          var a = obj[name];

          _this2.link(name, a);
        });
        return;
      } // Case: Contract.link(<libraryName>, <address>)


      if (this._json.networks[this.network_id] == null) {
        this._json.networks[this.network_id] = {
          events: {},
          links: {}
        };
      }

      this.network.links[name] = address;
    },
    // Note, this function can be called with two input types:
    // 1. Object with a bunch of data; this data will be merged with the json data of contract being cloned.
    // 2. network id; this will clone the contract and set a specific network id upon cloning.
    clone: function clone(json) {
      json = json || {};

      var temp = function TruffleContract() {
        this.constructor = temp;
        return Contract.apply(this, arguments);
      };

      temp.prototype = Object.create(this.prototype);
      var network_id; // If we have a network id passed

      if (typeof json !== "object") {
        network_id = json;
        json = this._json;
      }

      json = utils.merge({}, this._json || {}, json);
      temp._constructorMethods = this._constructorMethods;
      temp._properties = this._properties;
      temp._property_values = {};
      temp._json = json;
      bootstrap(temp);
      temp.interfaceAdapter = new InterfaceAdapter({
        networkType: temp.networkType
      });
      temp.web3 = new Web3Shim({
        networkType: temp.networkType
      });
      temp.class_defaults = temp.prototype.defaults || {};

      if (network_id) {
        temp.setNetwork(network_id);
      } // Copy over custom key/values to the contract class


      Object.keys(json).forEach(function (key) {
        if (key.indexOf("x-") !== 0) return;
        temp[key] = json[key];
      });
      return temp;
    },
    addProp: function addProp(key, fn) {
      var _this3 = this;

      var getter = function getter() {
        if (fn.get != null) {
          return fn.get.call(_this3);
        }

        return _this3._property_values[key] || fn.call(_this3);
      };

      var setter = function setter(val) {
        if (fn.set != null) {
          fn.set.call(_this3, val);
          return;
        } // If there's not a setter, then the property is immutable.


        throw new Error("".concat(key, " property is immutable"));
      };

      var definition = {};
      definition.enumerable = false;
      definition.configurable = false;
      definition.get = getter;
      definition.set = setter;
      Object.defineProperty(this, key, definition);
    },
    toJSON: function toJSON() {
      return this._json;
    },
    decodeLogs: utils.decodeLogs
  };
};